import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { snackbarActions, snackbarSelectors } from '../../redux';
import { Button, Theme } from '..';

import './snackbar.scss';

const Snackbar: FC = () => {
  const dispatch = useDispatch();
  const snackbar = useSelector(snackbarSelectors.getSnackbar);

  if (!snackbar.message) return null;
  return (
    <div className={`snackbar snackbar__${snackbar.type}`}>
      <span>{snackbar.message}</span>
      <Button theme={Theme.TRANSPARANT} icon='Close' onClickCallback={() => dispatch(snackbarActions.dismissMessage())} />
    </div>
  );
};
export default Snackbar;
